import { render, staticRenderFns } from "./zhongd.vue?vue&type=template&id=2bbc8f5d&scoped=true"
import script from "./zhongd.vue?vue&type=script&lang=js"
export * from "./zhongd.vue?vue&type=script&lang=js"
import style0 from "./zhongd.vue?vue&type=style&index=0&id=2bbc8f5d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbc8f5d",
  null
  
)

export default component.exports